<script>
    import _ from 'lodash'
    import $ from '../shared/helper'
    import Draggable from 'vuedraggable'
    import { CONST } from '../shared/constants'
    import { ATYPES } from '../state/types'
    import { FIELDS } from '../shared/fieldtypes'
    import VGridformField from './v-gridform-field.vue'
    import VGridformFieldToolbar from './v-gridform-field-toolbar.vue'
    import VRatingButton from './v-rating-button.vue'
    import VGridformBlock from './v-gridform-block.vue'

    export default {
        name: 'VGridformFieldList',
        components: { VRatingButton, VGridformFieldToolbar, VGridformField, VGridformBlock, Draggable },
        props: {
            name: {
                type: String,
                required: true,
                default: ''
            },
            list: {
                type: Array,
                required: true,
                default: () => []
            },
            config: {
                type: Object,
                required: true,
                default: () => null
            },
            rows: {
                type: Array,
                required: true,
                default: () => []
            },
            valid: {
                type: Boolean,
                default: false
            },
            callbacks: {
                type: Object,
                default: () => ({})
            },
            devTools: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                fieldlist: [],

                editConfig: {
                    size: 12,
                    flat: true,
                    center: false,
                    stacked: false,
                    padding: 'px-2',
                    destroy: true,
                    fieldstyle: 'filled',
                    dense: true,
                    moveable: false,
                    cls: 'mt-2',
                    fieldlistClass: 'vgf__fieldlist-edit-field',
                    contentClass: 'px-0',
                    actions: ['cancel', 'apply']
                },
                gfbName: `${CONST.GFBEDIT_NAME}-${this.name}`,
                gfbCallbacks: {
                    onFieldChange: this.updateField.bind(this),
                    onSubmitAction: this.submitField.bind(this),
                    onCancelAction: this.cancelField.bind(this),
                    onPrependInnerClick: this.onPrependInnerClick.bind(this)
                },

                blockDialog: false,
                blockCurrent: null,

                ratingDialog: false,
                ratingCurrent: null,
                ratingChip: null,
                ratingName: 'vgf-rating-edit',
                ratingConfig: {
                    header: this.$vuetify.lang.t('$vuetify.gfb.rating.header'),
                    destroy: true,
                    fieldstyle: 'outlined',
                    submitOnEnter: true,
                    actions: ['cancel', 'apply'],
                    rows: [
                        [
                            {
                                name: 'label',
                                label: this.$vuetify.lang.t('$vuetify.gfb.rating.label'),
                                required: true
                            }
                        ],
                        [
                            {
                                name: 'min',
                                label: this.$vuetify.lang.t('$vuetify.gfb.rating.min'),
                                type: 'number',
                                size: 6,
                                value: 0
                            },
                            {
                                name: 'max',
                                label: this.$vuetify.lang.t('$vuetify.gfb.rating.max'),
                                type: 'number',
                                size: 6
                            }
                        ],
                        [
                            {
                                name: 'failed',
                                label: this.$vuetify.lang.t('$vuetify.gfb.rating.failed'),
                                type: 'checkbox',
                                size: 12
                            }
                        ]
                    ]
                },
                ratingCallbacks: {
                    onSubmitAction: this.updateRating.bind(this),
                    onCancelAction: () => {
                        this.ratingDialog = false
                    }
                },

                isDragging: false,
                vgfflMenu: false,
                vgfflMenuItems: [],
                vgfflMenuX: 0,
                vgfflMenuY: 0,
                vgfflField: null
            }
        },

        computed: {
            fieldlistClasses() {
                const cls = this.config.fieldlistClass || ''
                return `vgf__fieldlist ${cls}`.trim()
            },
            fieldlistFocused() {
                return this.$store.getters[$.ns('fieldlistFocused', this.name)]
            },
            gf() {
                return this.$gridform[this.name]
            },
            moveable() {
                return this.config.fieldlistMoveable
            },
            canSubmit() {
                if (!this.config.validate) return true
                return this.valid && !this.config.disabled
            },
            dialogWidth() {
                let width
                switch(this.$vuetify.breakpoint.name) {
                    case 'xs': width = '98%'; break
                    case 'sm': width = '80%'; break
                    case 'lg': width = '40%'; break
                    case 'xl': width = '40%'; break
                    default: width = '60%'; break
                }
                return width
            }
        },
        watch: {
            list(list) {
                this.fieldlist = _.cloneDeep(list)
            },
            async fieldlistFocused() {
                await this.$nextTick()
                this.$autofocus(`.vgf__fh[data-id="${this.fieldlistFocused}"] .vgf__fh-fold`)
            }
        },

        mounted() {
            this.fieldlist = _.cloneDeep(this.list)
        },

        methods: {
            dispatch(action, payload) {
                if (!action) return Promise.resolve()
                return this.$store.dispatch($.ns(action, this.name), payload)
            },

            containerClasses(fieldlist) {
                let cls = this.fieldlistClasses || ''
                // cls += ' px-0'
                if (fieldlist.darken) cls += ' vgf__fieldlist--darken'
                if (fieldlist.id) cls += ' vgf__fieldlist--active'
                if (fieldlist.large) cls += ' vgf__fl--large'
                if (fieldlist.fullwidth) cls += ' vgf__fl--fullwidth'
                if (this.config.fieldlistFocusable && fieldlist.id === this.fieldlistFocused) cls += ' vgf__fieldlist--focused'
                // if (fieldlist.foldable !== false) cls += ' pl-1'
                return cls
            },
            // set right margin when rating is active
            fieldlistHeaderClasses(fieldlist) {
                let cls = 'px-1 '
                if (fieldlist.darken) cls += 'vgf__fh--darken '
                // add class for drag and drop handle
                if (this.moveable && fieldlist.id && fieldlist.moveable !== false) cls += 'vgf__fh-handle '
                if (this.config.rating && !fieldlist.internal) {
                    const large = this.config.rating.large ? '-large' : ''
                    // no menu if gridform is disabled (view mode)
                    const menu = this.config.rating.menu && !this.config.disabled ? '-menu' : ''
                    cls += `vgf__fh-rating${large}${menu} `
                }
                return cls.trim()
            },
            formLayoutClasses(fieldlist) {
                const direction = this.config.stacked ? 'column' : 'row'
                let layoutClass = this.config.layoutClass || ''
                let margins = ''
                // set needed rating classes
                // rating is active and fieldlist is valid for rating (not internal, not automatic)
                let hasRating = this.config.rating // gridform config
                if (fieldlist.internal) hasRating = false // internal
                if ((fieldlist.initials || '').charAt(0) === '_') hasRating = false // automatic
                if (!this.config.editable && !fieldlist.rating) hasRating = false
                if (hasRating) {
                    // no menu if gridform is disabled (view mode)
                    const menu = this.config.rating.menu && !this.config.disabled ? '-menu' : ''
                    layoutClass += ` vgf__rl-rating${menu}`
                    if (!fieldlist.id || fieldlist.id === 'default') layoutClass += ' vgf__rl--no-fieldlist'
                    margins = 'ml-0'
                }
                if (this.config.editable) margins = 'ml-2'
                if (fieldlist.internal) margins = 'mx-2' // has no rating and needs right margin too
                return `vgf__rl ${direction} ${layoutClass} ${margins}`.trim()
            },
            foldStateIcon(collapsed) {
                return collapsed ? CONST.EXPAND_ICON : CONST.COLLAPSE_ICON
            },
            rowsDataAttribute(fl) {
                if (fl.fieldlist.initials && fl.fieldlist.initials.charAt(0) === '_') return
                return fl.fieldlist.id || 'default'
            },

            // set focused fieldlist
            onFieldlistHeaderClick(fieldlist) {
                if (fieldlist.focused) return // already focused
                this.dispatch(ATYPES.GFFIELDLIST, { focused: fieldlist.id })
            },
            async onFieldlistInternalClick(fieldlist) {
                const answer = await this.$gridform.dialog({
                    title: 'Bemerkungen für den Mitarbeiter freigeben?',
                    description: 'Mitarbeiter mit Login können die Bemerkungen sehen',
                    submit: 'Freigeben'
                })
                if (!answer) return

                await this.dispatch(ATYPES.GFFIELDLIST, {id: fieldlist.id, internal: false, description: 'Allgemeine Verwendung'})
            },
            onSelect(event) {
                this.callbacks.onFieldSelect(event)
            },
            onSubmit() {
                if (this.config.submitOnEnter && this.canSubmit) this.$emit('submit')
            },
            onClick(event) {
                this.callbacks.onFieldClick(event)
            },
            async onEditAction(action, field, data) {
                if (/^(up|down|first|last)$/i.test(action)) {
                    await this.dispatch(ATYPES.GFMOVEROW, {name: field.name, direction: action})
                }
                else if (action === 'edit') {
                    this.gf.edit(field.name)
                }
                else if (action === 'cancel') {
                    this.cancelField(field)
                }
                else if (action === 'save') {
                    this.submitField(null, field)
                }
                else if (action === 'delete') {
                    const name = field.name
                    const type = data.def.type
                    this.$gridform.dialog({
                        message: this.$vuetify.lang.t('$vuetify.gfb.block.deleteMessage'),
                        text: field.label,
                        submit: this.$vuetify.lang.t('$vuetify.gfb.actions.delete')
                    }).then(submitted => {
                        if (submitted) {
                            this.callbacks.onFieldDelete({...data.def, type})
                            this.dispatch(ATYPES.REMOVE_FIELD, {name})
                        }
                    })
                }
                else if (action === 'clone') {
                    const focusedFl = this.gf.fieldlistFocus()
                    const item = _.cloneDeep(field)
                    item.name = _.uniqueId(`${CONST.GFB_NAME}-${_.now()}-`)
                    item.type = data.def.type

                    // ask for position if focused fieldlist exists
                    let inGroup = false
                    if (_.get(focusedFl, 'fieldlist.id')) {
                        const icon = FIELDS[item._type || 'text'].icon
                        inGroup = await $.cloneBlockConfirmation({ ...item, icon })
                        if (typeof inGroup === 'undefined') return
                    }

                    const rows = [[{...item}]]
                    // add to focused fieldlist or to end
                    const fieldlist = inGroup ? {...focusedFl.fieldlist} : null
                    this.gf.add({ rows, fieldlist })
                }
                else if (action === 'export') {
                    this.$json.open({ field, data })
                }
                else if (action === 'selection') {
                    await this.dispatch(ATYPES.GFDATA, {[field.name]: {selected: !data.selected}})
                    this.callbacks.onFieldSelection(field, data)
                }
                else {
                    console.log('action', field, action)
                }
            },
            onHover(payload) {
                this.callbacks.onFieldHover(payload)
            },
            onHoverChange(payload) {
                this.callbacks.onHoverChange(payload)
            },
            onFab(field) {
                this.callbacks.onFabClick(field)
                if (!this.config.rating || !this.config.editable) return
                if (field && field.fieldlist) return // no rating dialog for fieldlists
                if (field.rating !== true && field.rating.maxValue !== 'rating') return // no rating for controls with fixed rating values

                this.ratingCurrent = field
                this.ratingDialog = true
                this.$nextTick(() => {
                    const gfRating = this.$gridform[this.ratingName]
                    if (gfRating) {
                        gfRating.hide(['label'])
                        gfRating.values({
                            label: field.label,
                            min: _.get(field, 'rating.min', 0),
                            max: _.get(field, 'rating.max', 1)
                        })
                    }
                    else console.warn('gfRating not found!')
                })
            },
            onMin(item) {
                this.callbacks.onFabAction({action: 'min', item})
            },
            onMax(item) {
                this.callbacks.onFabAction({action: 'max', item})
            },
            onUp(item) {
                this.callbacks.onFabAction({action: 'up', item})
            },
            onDown(item) {
                this.callbacks.onFabAction({action: 'down', item})
            },
            onExclude(item) {
                this.callbacks.onFabAction({action: 'exclude', item})
            },
            onInclude(item) {
                this.callbacks.onFabAction({action: 'include', item})
            },
            onWeighting(item, weighting) {
                this.callbacks.onFabAction({action: 'weighting', item, weighting})
            },
            onPrependInnerClick(field) {
                if (field.name === 'customLabels') {
                    // field.value = _.range(field.m)
                    // field.tickLabels = ''
                }
            },
            onPrependInner(field) {
                this.callbacks.onPrependInnerClick(field)
            },
            onAppend(field) {
                this.callbacks.onAppendClick(field)
                // TODO validate link
                if (field.type === 'link' && field.value) {
                    window.open(field.value, '_blank', 'noopener,noreferrer')
                }
            },
            onChip(field, item) {
                this.ratingCurrent = field
                this.ratingChip = item
                this.ratingDialog = true
                this.$nextTick(() => {
                    this.$gridform[this.ratingName].hide(['min', 'failed'])
                    this.$gridform[this.ratingName].values({
                        label: item.label,
                        min: item.avatar,
                        max: item.avatar
                    })
                })
            },
            onClickDescriptions(d, event) {
                if (!d || !event || !event.target) return
                const field = _.first(this.gf.field({name: d.name}))
                if (!field) return

                const rect = event.target.getBoundingClientRect()
                this.vgfflField = field.name
                this.vgfflMenuY = rect.bottom
                this.vgfflMenuX = rect.left - 12
                this.vgfflMenuItems = field.items.filter(item => item.value !== field.value)
                this.vgfflMenu = true
            },
            onRemoveDescriptions(d) {
                if (!d || !d.name) return

                const values = {}
                if (Array.isArray(d.name)) {
                    _.each(d.name, fname => {
                        if (fname === 'ratingfrom') values[fname] = 0
                        else if (fname === 'ratingto') values[fname] = 100
                        else values[fname] = ''
                    })
                }
                else {
                    const field = _.first(this.gf.field({name: d.name}))
                    if (!field) return
                    if (field.toggle) _.each(field.toggle, fname => {values[fname] = ''})
                    else values[d.name] = ''
                }
                this.gf.values(values)
            },
            onMenuItemClick(item) {
                if (!item) return

                this.vgfflMenu = false
                this.vgfflMenuItems = []
                this.gf.values({[this.vgfflField]: item.value})
            },
            onErrorClick(error) {
                this.$autofocus(`[name="${error.name}"]`)
            },
            onActivateFieldlist(fl) {
                this.dispatch(ATYPES.GFFIELDLIST, {id: fl.fieldlist.id, activate: true, activated: true})
            },
            async onDeactivateFieldlist(fieldlist) {
                const answer = await this.$gridform.dialog({
                    description: this.$vuetify.lang.t('$vuetify.gfb.block.deactivateHint'),
                    submit: this.$vuetify.lang.t('$vuetify.gfb.block.deactivate')
                })
                if (answer) await this.dispatch(ATYPES.GFFIELDLIST, {id: fieldlist.id, activate: true, activated: false})
            },

            updateRating(formdata) {
                this.ratingDialog = false
                const fieldName = this.ratingCurrent.name

                if (this.ratingChip && this.ratingChip.avatar) {
                    const chip = this.ratingCurrent.value.find(v => v.value === this.ratingChip.value)
                    if (chip) {
                        chip.label = formdata.label
                        chip.avatar = `${formdata.max}`
                        const update = {[fieldName]: {value: this.ratingCurrent.value}}
                        this.dispatch(ATYPES.GFCHANGE, update)
                    }
                    return
                }

                const rating = {...formdata}
                rating.score = rating.min
                const update = {[fieldName]: {rating, ratingScroll: true}}
                this.dispatch(ATYPES.GFCHANGE, update)
            },
            showRatingButton(fieldlist) {
                if (!this.config.rating) return false
                if (fieldlist.activate && !fieldlist.activated) return false
                if (fieldlist.internal) return false
                if (fieldlist.noRating) return true
                return !!fieldlist.rating
            },

            // get edit field gridform name
            gfFieldName(field) {
                return `${this.gfbName}-${field.name}`
            },
            // set properties from update to current field
            updateField(update, field) {
                if (!field || !update) return

                // from update: {max: {value: 3}} to chg: {max: 3}
                const chg = $.payloadToStore(update)
                if (_.has(chg, 'min') || _.has(chg, 'max')) {
                    // calculate new tick labels for the edited field
                    const min = _.isUndefined(chg.min) ? field.min : chg.min
                    const max = _.isUndefined(chg.max) ? field.max : chg.max
                    chg.tickLabels = calcTickLabels(min, max, field.step)
                    // check if tickLabels exists in the gridform
                    // update calculated tick labels in edit formular
                    const gfb = this.$gridform[this.gfFieldName(field)]
                    if (gfb) {
                        const hasTickLabels = !_.isUndefined(_.find(gfb.field(), {name: 'tickLabels'}))
                        if (hasTickLabels) gfb.values({tickLabels: chg.tickLabels})
                    }
                }
                // trim trailing whitespace in hint
                if (_.has(chg, 'hint')) chg.hint = chg.hint.trim()
                const changes = {[field.name]: chg}
                this.dispatch(ATYPES.GFCHANGE, changes)

                function calcTickLabels(min, max, step) {
                    const tl = _.range(min, max + 1, step)
                    return tl.toString() // [0,1,2,3] -> 0,1,2,3
                }
            },
            // take data as is and stop edit mode
            submitField(data, field) {
                this.dispatch(ATYPES.GFCHANGE, {[field.name]: {editMode: false}})
            },
            // reset data and stop edit mode
            cancelField(field) {
                const gfName = this.gfFieldName(field)
                const rollback = this.$store.getters[$.ns('rollback', gfName)]
                if (rollback) this.updateField(rollback, field)
                this.dispatch(ATYPES.GFCHANGE, {[field.name]: {editMode: false}})
            },

            // open dialog with gridform for block editing
            editBlock(block) {
                this.blockCurrent = block
                this.blockDialog = true
            },
            // dispatch new block data
            updateBlock(block) {
                const id = this.blockCurrent.id
                const payload = {id, ...block}
                this.dispatch(ATYPES.GFFIELDLIST, payload)
                if (this.blockCurrent.export !== payload.export) {
                    // set all fields in fieldlist to new export state
                    // NOTE this will overwrite the current field export state
                    const fl = this.gf.fieldlist().find(fl => fl.fieldlist.id === id)
                    if (fl && !_.isEmpty(fl.rows)) {
                        const update = {}
                        _.flatten(fl.rows).forEach(col => {
                            update[col.name] = {export: payload.export}
                        })
                        this.gf.update(update)
                    }
                }
                this.blockDialog = false
            },
            unBlock(block) {
                this.callbacks.onRowsChange({rows: _.cloneDeep(this.rows), action: 'unblock'})
                this.dispatch(ATYPES.GFFIELDLIST, {id: block.id, remove: true})
            },
            toggleBlock(block) {
                block.collapsed = !block.collapsed
                this.callbacks.onFieldsetToggle(block.collapsed, block)
                this.dispatch(ATYPES.GFFIELDLIST, {id: block.id, toggle: true, collapsed: block.collapsed})
            },
            saveBlock(block) {
                // this.blockDialog = true
                // this.blockCurrent = {...block}
                block.config = this.$gridform[this.name].export()
                block.values = $.formToStore(this.$gridform[this.name].data())
                this.callbacks.onBlockCreate(block)
            },
            resetBlock(block) {
                this.callbacks.onBlockReset(block)
            },
            removeBlock(block) {
                this.callbacks.onRowsChange({rows: _.cloneDeep(this.rows), action: 'blockremove'})
                this.callbacks.onBlockRemove(block)
            },

            // move a block
            moveBlockFirst(block) {
                this.gf.fieldlistMove({command: 'first', id: block.id})
            },
            moveBlockUp(block) {
                this.gf.fieldlistMove({command: 'up', id: block.id})
            },
            moveBlockDown(block) {
                this.gf.fieldlistMove({command: 'down', id: block.id})
            },
            moveBlockLast(block) {
                this.gf.fieldlistMove({command: 'last', id: block.id})
            },

            // drag and drop for fieldlists and fields
            // event handler: fieldlist moved
            onDrag(newList) {
                this.callbacks.onRowsChange({rows: _.cloneDeep(this.rows), action: 'blockmove'})
                // rebuild rows in order of new list
                this.updateRows(newList)
            },
            // event handler: field moved
            // NOTE field moved inside fieldlist, we get 1 event (moved)
            // NOTE field moved to other fieldlist, we get 2 events (first added, second removed)
            onMoved(event) {
                if (!event || event.removed) return

                this.callbacks.onRowsChange({rows: _.cloneDeep(this.rows), action: 'fieldmove'})
                // rebuild rows and copy fieldlist to fields
                this.updateRows(this.fieldlist, !event.moved)
            },
            updateRows(list, updateFieldlist) {
                const rows = $.fieldlistToRows(list, updateFieldlist)
                this.gf.rows({rows})
            },
            onChoose() {
                this.isDragging = true
            },
            onMoveStart() {
                this.isDragging = true
            },
            onMoveEnd() {
                this.isDragging = false
            }
        }
    }
</script>

<template>
    <div>
        <Draggable
            v-model="fieldlist"
            group="fieldlist"
            :disabled="!moveable"
            handle=".vgf__fh-handle"
            :force-fallback="true"
            @input="onDrag"
            @choose="onChoose"
            @start="onMoveStart"
            @end="onMoveEnd">
            <!-- fieldlist container for row and column layout, fluid = no max-width -->
            <VContainer v-for="(fl, fli) in fieldlist" :key="fli"
                :class="containerClasses(fl.fieldlist)"
                :fluid="config.fluid"
                :style="{ backgroundColor: config.color }">
                <!-- fieldlist header -->
                <VSubheader v-if="fl.fieldlist.id"
                    class="vgf__fh"
                    :class="fieldlistHeaderClasses(fl.fieldlist)"
                    :data-id="fl.fieldlist.id"
                    @click.left="onFieldlistHeaderClick(fl.fieldlist)">
                    <VTooltip v-if="fl.fieldlist.activate && !fl.fieldlist.activated && !config.editable && !config.disabled" bottom>
                        <template v-slot:activator="{ on }">
                            <VBtn icon v-on="on" @click.left="onActivateFieldlist(fl)">
                                <VIcon>mdi-checkbox-blank-circle-outline</VIcon>
                            </VBtn>
                        </template>
                        <span>{{ $vuetify.lang.t('$vuetify.gfb.field.fieldtoggleHint') }}</span>
                    </VTooltip>
                    <VBtn v-else-if="fl.fieldlist.foldable !== false" class="vgf__fh-fold" icon small @click.left="toggleBlock(fl.fieldlist)">
                        <VIcon small v-text="foldStateIcon(fl.fieldlist.collapsed)"/>
                    </VBtn>
                    <div v-if="fl.fieldlist.initials" class="font-weight-bold ml-2" style="min-width: 100px; font-size:12px">{{ fl.fieldlist.initials }}</div>
                    <VMenu v-if="fl.errorCount">
                        <template v-slot:activator="{on}">
                            <VChip small label color="error" class="mx-2 font-weight-bold" v-on="on">{{ fl.errorCount }}</VChip>
                        </template>

                        <VList dense>
                            <VListItem v-for="error in fl.errors" :key="error.name" @click.left="onErrorClick(error)">
                                <VListItemContent>
                                    <VListItemTitle>{{ error.label }}</VListItemTitle>
                                    <VListItemSubtitle>{{ error.error }}</VListItemSubtitle>
                                </VListItemContent>
                            </VListItem>
                        </VList>
                    </VMenu>
                    <div v-if="fl.fieldlist.descriptions" class="flex pl-2" style="max-width:90%">
                        <VChipGroup show-arrows>
                            <VChip v-for="d in fl.fieldlist.descriptions" :key="d.key || d.name"
                                   class="vgf__fh--descriptions"
                                   small
                                   label
                                   outlined
                                   :close="d.close !== false"
                                   close-icon="mdi-close"
                                   @click="d.select ? onClickDescriptions(d, $event) : null"
                                   @click:close="onRemoveDescriptions(d)"
                            >
                                <VIcon v-if="d.left" left>{{ d.left }}</VIcon>
                                {{ d.text }}
                                <VIcon v-if="d.right" right>{{ d.right }}</VIcon>
                            </VChip>
                        </VChipGroup>
                    </div>
                    <div v-else-if="fl.fieldlist.name || fl.fieldlist.description" class="vgf__fieldlist-hint ml-1">
                        <span v-if="fl.fieldlist.name" class="font-weight-bold pr-4">{{ fl.fieldlist.name }}</span>
                        <span v-if="fl.fieldlist.description" :title="fl.fieldlist.description">{{ fl.fieldlist.description }}</span>
                    </div>
                    <div v-if="fl.fieldlist.internal" class="vgf__fieldlist-internal">
                        <VIcon x-small :disabled="config.disabled" @click.left="onFieldlistInternalClick(fl.fieldlist)">mdi-lock</VIcon>
                    </div>
                    <div v-if="config.editable && fl.fieldlist.activate" class="vgf__fieldlist-fieldtoggle">
                        <VIcon x-small :disabled="config.disabled">mdi-check-circle-outline</VIcon>
                    </div>
                    <div v-if="!config.editable && fl.fieldlist.activated" class="vgf__fieldlist-fieldtoggle">
                        <VIcon small color="success" @click.left="onDeactivateFieldlist(fl.fieldlist)">mdi-check-circle</VIcon>
                    </div>

                    <VSpacer/>

                    <!-- Reset -->
                    <VTooltip v-if="fl.fieldlist.resetable && !config.disabled" bottom>
                        <template v-slot:activator="{ on }">
                            <VBtn icon small class="mr-2" v-on="on" @click.left="resetBlock(fl.fieldlist)">
                                <VIcon>mdi-file-restore-outline</VIcon>
                            </VBtn>
                        </template>
                        <span>{{ $vuetify.lang.t('$vuetify.actions.reset') }}</span>
                    </VTooltip>
                    <!-- Edit -->
                    <VTooltip v-if="fl.fieldlist.editable && !config.disabled" bottom>
                        <template v-slot:activator="{ on }">
                            <VBtn icon small v-on="on" @click.left="editBlock(fl.fieldlist)">
                                <VIcon small>mdi-pencil</VIcon>
                            </VBtn>
                        </template>
                        <span>{{ $vuetify.lang.t('$vuetify.gfb.block.editTitle') }}</span>
                    </VTooltip>
                    <!-- Delete -->
                    <VTooltip v-if="fl.fieldlist.editable && !config.disabled" bottom>
                        <template v-slot:activator="{ on }">
                            <VBtn icon small v-on="on" @click.left="removeBlock(fl.fieldlist)">
                                <VIcon small>mdi-trash-can-outline</VIcon>
                            </VBtn>
                        </template>
                        <span>{{ $vuetify.lang.t('$vuetify.gfb.deleteHint') }}</span>
                    </VTooltip>
                    <!-- Ungroup -->
                    <VTooltip v-if="fl.fieldlist.editable && !config.disabled" bottom>
                        <template v-slot:activator="{ on }">
                            <VBtn icon small v-on="on" @click.left="unBlock(fl.fieldlist)">
                                <VIcon small>mdi-ungroup</VIcon>
                            </VBtn>
                        </template>
                        <span>{{ $vuetify.lang.t('$vuetify.gfb.ungroupHint') }}</span>
                    </VTooltip>
                    <!-- Save -->
                    <VTooltip v-if="fl.fieldlist.editable && !config.disabled" bottom>
                        <template v-slot:activator="{ on }">
                            <VBtn icon small v-on="on" @click.left="saveBlock(fl.fieldlist)">
                                <VIcon small>mdi-content-save-outline</VIcon>
                            </VBtn>
                        </template>
                        <span>{{ $vuetify.lang.t('$vuetify.gfb.saveHint') }}</span>
                    </VTooltip>

                    <VRatingButton
                        v-if="showRatingButton(fl.fieldlist)"
                        :disabled="config.disabled || config.rating.disabled"
                        :options="fl.fieldlist"
                        :absolute="true"
                        :dense="true"
                        :large="config.rating.large"
                        width="2"
                        :menu="config.rating.menu"
                        :toggle-hint="config.rating.toggleHint"
                        @fab="onFab(fl)"
                        @min="onMin(fl)"
                        @max="onMax(fl)"
                        @exclude="onExclude(fl)"
                        @include="onInclude(fl)"
                        @weighting="onWeighting(fl, $event)"
                    />
                </VSubheader>
                <!-- fieldlist fields -->
                <template v-if="!fl.fieldlist.collapsed">
                    <Draggable
                        class="vgf__rows"
                        :data-fl="rowsDataAttribute(fl)"
                        :list="fl.rows"
                        group="field"
                        :disabled="!moveable"
                        handle=".vgf__rl-handle"
                        filter=".vgf-draggable-ignore"
                        :force-fallback="true"
                        @change="onMoved"
                        @choose="onChoose"
                        @start="onMoveStart"
                        @end="onMoveEnd">
                        <VLayout v-for="(row, i) in fl.rows" :key="i" :data-key="i" :data-index="fl.index" :class="formLayoutClasses(fl.fieldlist)">
                            <VGridformField
                                v-for="(col, j) in row"
                                :key="`${col.name}-${i}-${j}`"
                                :name="name"
                                :field="col"
                                :rowinfo="[fli, i, j, fli + i, fl.rows.length, rows.length]"
                                @click="onClick"
                                @select="onSelect"
                                @hover="onHover"
                                @hoverchange="onHoverChange"
                                @submit="onSubmit"
                                @click:chip="onChip"
                                @click:append="onAppend"
                                @click:prepend-inner="onPrependInner">
                                <!-- Toolbar when edit the field properties -->
                                <template v-slot:prepend="{ field, cfg, rowinfo, data }">
                                    <VGridformFieldToolbar
                                        v-if="cfg.editable && data && data.def && data.def.type !== 'spacer'"
                                        :field="field"
                                        :rowinfo="rowinfo"
                                        :data="data"
                                        :show-type="data.def.type === 'gap'"
                                        :dev-tools="devTools"
                                        @action="onEditAction"/>
                                </template>

                                <!-- Form when edit the field properties -->
                                <template v-slot:append="{ field }">
                                    <VGridform
                                        v-if="field.editMode"
                                        :name="gfFieldName(field)"
                                        :config="editConfig"
                                        :context="field"
                                        :callbacks="gfbCallbacks"/>
                                </template>

                                <!-- Rating and scores -->
                                <template v-slot:rating="{ field, cfg }">
                                    <VRatingButton
                                        v-if="cfg.rating && !fl.fieldlist.noRating && field.rating !== false"
                                        :disabled="cfg.disabled || cfg.rating.disabled"
                                        :options="field"
                                        :absolute="true"
                                        :dense="true"
                                        :large="false"
                                        :menu="cfg.rating.menu"
                                        width="2"
                                        @fab="onFab(field)"
                                        @min="onMin(field)"
                                        @max="onMax(field)"
                                        @up="onUp(field)"
                                        @down="onDown(field)"
                                        @exclude="onExclude(field)"
                                        @include="onInclude(field)"
                                        @weighting="onWeighting(field, $event)"/>
                                </template>
                            </VGridformField>
                        </VLayout>
                    </Draggable>
                </template>
            </VContainer>
        </Draggable>

        <VMenu ref="menu" v-model="vgfflMenu" :position-x="vgfflMenuX" :position-y="vgfflMenuY">
            <VList dense>
                <VListItem v-for="item in vgfflMenuItems" :key="item.value" @click.left="onMenuItemClick(item)">
                    <VListItemTitle>{{ item.text }}</VListItemTitle>
                </VListItem>
            </VList>
        </VMenu>
        <VDialog v-model="blockDialog" :max-width="dialogWidth" persistent>
            <VGridformBlock :block="blockCurrent" :dev-tools="devTools" @cancel="blockDialog = false" @submit="updateBlock"/>
        </VDialog>
        <VDialog v-model="ratingDialog" :max-width="dialogWidth" persistent>
            <VGridform :name="ratingName" :config="ratingConfig" :callbacks="ratingCallbacks"/>
        </VDialog>
    </div>
</template>

<style lang="scss" scoped>
    .vgf__rows {
        margin-top: 8px;
    }
    .vgf__fieldlist {
        position: relative;
        padding: 0 24px;
        margin-bottom: 8px;
        border-width: 2px;
        border-color: transparent;
    }
    .vgf__fieldlist--active {
        width: calc(100% - 40px);
        border-style: dotted;
        border-radius: 4px;
        &.vgf__fieldlist--darken {
            border-radius: 0;
        }
    }
    .vgf__fieldlist--active.vgf__fieldlist--focused {
        border-style: solid;
    }
    .vgf__fh {
        position: relative;
        margin-top: 8px;
        margin-bottom: 8px;
        &.vgf__fh--darken {
            &.theme--light {
                background-color: #F5F5F5;
            }
            &.theme--dark {
                background-color: #1E1E1E;
            }
        }
    }
    .vgf__fl--fullwidth {
        width: 100%;
        padding-right: 0;
        padding-left: 0;
        margin-bottom: 0;
        border-color: #F5F5F5 !important;
    }
    .vgf__fl--large .vgf__fh {
        height: 60px;
    }
    .vgf__fh-handle,
    .vgf__rl-handle {
        cursor: move;
        &:active {
            cursor: grabbing;
        }
    }
    .vgf__rl {
        border-radius: 4px;
    }
    .vgf__fieldlist-hint {
        display: block;
        max-height: 40px;
        line-height: 20px;
        overflow: hidden;
        font-weight: 400;
        text-overflow: ellipsis;
    }
    .font-weight-bold {
        color: rgba(10, 0, 10, 0.87);
    }
    .vgf__fieldlist-weighting {
        font-size: 80%;
        line-height: 1;
    }
    .vgf__fh--descriptions {
        margin: 0 2px 2px 0;
    }
    .vgf__card {
        &.theme--dark .vgf__fieldlist {
            border-color: rgba(255, 255, 255, 0.35);
            &.vgf__fieldlist--focused {
                border-color: #1c3257;
            }
        }
        &.theme--light .vgf__fieldlist {
            border-color: rgba(10, 0, 10, 0.27);
            &.vgf__fieldlist--focused {
                border-color: rgba(28, 50, 87, 0.67);
            }
        }
    }
    .vgf__footer-right {
        position: absolute;
        right: 1px;
        bottom: -30px;
    }
    .vgf__fieldlist-internal {
        position: absolute;
        top: 12px;
        left: 126px;
    }
    .vgf__fieldlist-fieldtoggle {
        position: absolute;
        top: 12px;
        left: 126px;
    }

    /* see absolute positioning in v-rating-button.vue */
    .vgf__fh-rating {
        margin-right: 45px !important;
    }
    .vgf__fh-rating-large {
        margin-right: 54px !important;
    }
    .vgf__fh-rating-large-menu {
        margin-right: 90px !important;
    }
    .vgf__rl-rating {
        margin-right: 45px !important;
    }
    .vgf__rl-rating-menu {
        margin-right: 80px !important;
    }
    .vgf__rl-rating.vgf__rl--no-fieldlist {
        margin-right: 65px !important;
    }
    .vgf__rl-rating-menu.vgf__rl--no-fieldlist {
        margin-right: 100px !important;
    }

    .sortable-ghost {
        border: 2px dashed rgba(0, 0, 0, 0.6) !important;
        > * {
            visibility: hidden !important;
        }
    }
</style>
<style lang="scss">
    .vgf__fieldlist-edit-field {
        #vgf-f-items {
            .v-chip .v-avatar {
                cursor: pointer;
            }
        }
    }
</style>
